module.exports = __webpack_public_path__ + "img/dsci0095.ba495b7e.jpg";